/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type SputumTestMaterialResultDtoDetectionMethod =
  (typeof SputumTestMaterialResultDtoDetectionMethod)[keyof typeof SputumTestMaterialResultDtoDetectionMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SputumTestMaterialResultDtoDetectionMethod = {
  MICROSCOPIC_DIRECT_DETECTION: 'MICROSCOPIC_DIRECT_DETECTION',
  MOLECULAR_BIOLOGICAL_DIRECT_DETECTION: 'MOLECULAR_BIOLOGICAL_DIRECT_DETECTION',
  CULTURE: 'CULTURE',
} as const;
